// extracted by mini-css-extract-plugin
export default {"wrap":"FeedBack_wrap__1YWb5","head":"FeedBack_head__YWAQ6","title":"FeedBack_title__p35ap","starsWrap":"FeedBack_starsWrap__yOn51"};